import React from "react";
import { Card, Icon, Title, Tooltip } from "@skyportal/ui-kit";
import { useTranslation } from "react-i18next";
import Top5BucketsChart from "./Top5BucketsChart";
import { top5BucketsMock } from "./mocks";

import styles from "./Top5BucketsChartCard.module.css";

const Top5BucketsChartCard: React.FC = () => {
  const { t } = useTranslation("storageOverview");
  return (
    <Card
      className={styles.card}
      title={
        <div className={styles.chartTitleContainer}>
          <Title level={5}>{t("charts.topBucketsTitle")}</Title>

          <Tooltip title={t("charts.topBucketsTooltip")}>
            <div className={styles.tooltipIcon}>
              <Icon icon="info" height={16} color="black" />
            </div>
          </Tooltip>
        </div>
      }
    >
      <Top5BucketsChart data={top5BucketsMock} />
    </Card>
  );
};

export default Top5BucketsChartCard;
